import { useEffect } from "react";
import { useContent } from "@/context/ContentContext";
import { assetUrl } from "@/lib/api";

// Dynamically updates the browser tab icon + title from admin-managed content.
export const HeadManager = () => {
  const { content } = useContent();

  useEffect(() => {
    if (!content?.brand) return;
    const { favicon, name } = content.brand;

    if (name) document.title = `${name} — ${content.brand.tagline || "Bimbingan Belajar"}`;

    if (favicon) {
      const href = assetUrl(favicon);
      let link = document.querySelector('link[rel="icon"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = href;
    }
  }, [content]);

  return null;
};
